// extracted by mini-css-extract-plugin
export default {"highlightedTailCell":"style_highlightedTailCell__qh9WH","greyShadedRow":"style_greyShadedRow__aH3zk","blueShadedRow":"style_blueShadedRow__MtlKG"};